// Tiny logging shim. `debug` is a no-op in production so verbose editor/render
// tracing never ships to users' consoles; `warn` / `error` always pass through.
/* eslint-disable no-console */
const debug = process.env.NODE_ENV !== 'production' ? console.log.bind(console) : () => {};
const warn = console.warn.bind(console);
const error = console.error.bind(console);
/* eslint-enable no-console */

const logger = {debug, warn, error};

export default logger;
